import type { Task, TaskCreate, TaskUpdate } from "~/shared/types";
import type { DataStore } from "~/stores/DataStore";

type TaskAny = Task | TaskUpdate | TaskCreate;

export const checkTaskKindStatusConstraint = (
  kindDuid: TaskAny["kindDuid"],
  statusDuid: TaskAny["statusDuid"],
  dataStore: DataStore
): Partial<TaskAny> => {
  if (!kindDuid || !statusDuid) {
    return {};
  }

  const taskKind = dataStore.getTaskKindByDuid(kindDuid);
  const status = dataStore.getStatusByDuid(statusDuid);
  if (!taskKind || !status) {
    return {};
  }

  const availableStatuses = dataStore.getStatusList(dataStore.defaultStatusProperty, [taskKind]);
  if (availableStatuses.some((e) => e.duid === statusDuid)) {
    return {};
  }

  return { statusDuid: dataStore.defaultUnstartedStatus(dataStore.defaultStatusProperty).duid };
};

export const checkTaskConstraints = (update: TaskAny, dataStore: DataStore): Partial<TaskAny> => {
  const currentTask = dataStore.getTaskByDuidIfLoaded(update.duid);
  const task: TaskAny = { ...currentTask, ...update };

  const suggestedUpdate: Partial<TaskAny> = {
    ...checkTaskKindStatusConstraint(task.kindDuid, task.statusDuid, dataStore),
  };

  return suggestedUpdate;
};
